export default __webpack_public_path__ + "static/media/faceYellow.44f3a219.svg";